import Link from 'next/link'
import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function MfaSetup () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' },
    { name: 'MFA Setup', href: '/login-help/mfa-setup' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>Multifactor Authentication Setup</h2>

      <Card>
        <CardBody>
          <p>
            Multi-factor Authentication is a way of confirming a user’s identity by verifying that the user has two or more pieces of information.
            This is usually accomplished by verifying something the user knows (such as a password) and something they have in their possession (such as a mobile device).
          </p>
          <p>
            SCP, like many other security conscious enterprises, requires multi-factor authentication when logging into company systems.
            After entering your username and password, you may be prompted for another piece of information to log in.
            This second bit of information (factor) is a code that is generated on or sent to your mobile device.
          </p>
          <p>
            Upon logging into an SCP system for the first time, you will be instructed to select a form of additional authentication.
            We provide a number of authentication methods:
            <ul>
              <li>
                Okta Verify - Use an app available on iOS and Android to enter a secret code or authenticate through a push notification
              </li>
              <li>
                SMS Verification - Receive a text message containing a code
              </li>
              <li>
                Voice Call Verification - Receive an automated voice call to obtain a code
              </li>
            </ul>
          </p>
          <p>
            Okta Verify is the recommended authentication method.
            The push notifications it sends are simple and faster than the other methods.
            However, if you are unable to use the app or prefer not to, feel free to choose one of the other methods.
            You can change your authentication method at any time from your account settings page.
            To do so, refer to the Changing Authentication Methods section.
          </p>
          <hr />
          <h2>Setup</h2>
          <p>
            When logging in for the first time, Okta will ask you how you would like to set up multi-factor authentication.
            Click Setup under the desired authentication method, then follow the instructions below to enable it.
            You can set up multiple authentication methods which will allow you to choose between them each time you log in.
            To do so, after you have set up a method, click Setup under any additional methods you would like to use.
            See <Link href='/login-help'><a>Login Help</a></Link> for more info detailing how to setup each and editing your preferences.
          </p>
          <p>
            Please note that if you wish to use voice call verification, it must be set up after you log in for the first time.
            See <Link href='/login-help/change-auth-methods'><a>Change Authentication Methods</a></Link> for info on how to do this.
          </p>
          <img src='/static/img/mfa-setup.png' alt='mfa setup' />
        </CardBody>
      </Card>
    </>
  )
}

MfaSetup.publicAccess = true

MfaSetup.getInitialProps = () => ({
  title: 'MFA Setup'
})

export default MfaSetup
